import { useEffect, useState } from "react";
import { useParams, Navigate, Link as RouterLink } from "react-router-dom";
import { Alert, Box, Button, Chip, Container, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { OrderController } from "../controllers/order";
import { useAuth } from "../context/AuthContext";

export default function Order() {
  const { id } = useParams();
  const { user, loading } = useAuth();
  const [o, setO] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (!user) return;
    OrderController.get(id).then(setO).catch((e) => setErr(e.message));
  }, [user, id]);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (err) return <Container sx={{ py: 6 }}><Alert severity="error">{err}</Alert></Container>;
  if (!o) return <Container sx={{ py: 6 }}><Typography>Loading…</Typography></Container>;

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
        <Typography variant="h2" sx={{ fontSize: "1.8rem" }}>Order {o.number || o.id}</Typography>
        <Chip label={o.status || "pending"} />
      </Stack>
      <Paper sx={{ mb: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>SKU</TableCell>
              <TableCell>Description</TableCell>
              <TableCell align="right">Qty</TableCell>
              <TableCell align="right">Unit</TableCell>
              <TableCell align="right">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(o.lines || o.items || []).map((l, i) => (
              <TableRow key={i}>
                <TableCell>{l.sku}</TableCell>
                <TableCell>{l.description}</TableCell>
                <TableCell align="right">{l.qty}</TableCell>
                <TableCell align="right">{l.unitPrice ? `$${Number(l.unitPrice).toFixed(2)}` : "—"}</TableCell>
                <TableCell align="right">{l.total ? `$${Number(l.total).toFixed(2)}` : "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
      <Box sx={{ textAlign: "right" }}>
        <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 2 }}>
          Total: {o.total ? `$${Number(o.total).toFixed(2)}` : "—"}
        </Typography>
        <Button component={RouterLink} to="/orders" variant="outlined">Back to Orders</Button>
      </Box>
    </Container>
  );
}
